/* eslint-disable no-useless-concat */
import React, { useState, useContext, useRef } from "react";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import { obtenerStoresConfig, uploadFile, auditPost } from "../../api/config";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../GlobalContext";

const Restaurant = () => {
	const { isGranted, getModuleId, site_id } = useContext(GlobalContext);
	const [selectedFile, setSelectedFile] = useState(null);
	const { t } = useTranslation();
	const [isDownloading, setIsDownloading] = useState(false);
	const [isUploading, setIsUploading] = useState(false);

	const handleClickButton = async () => {
		setIsDownloading(true);
		try {
			const siteArray = [site_id];
			const datosForecast = await obtenerStoresConfig(
				`/files/config_stores_file?site_id=${site_id}`,
				siteArray
			);
			//dowload file
			const url = window.URL.createObjectURL(new Blob([datosForecast]), {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "Sitio" + ".xlsx");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			const moduleId = getModuleId("Carga de Archivos", "Restaurante", "Botón de descargar formato");
			auditPost(moduleId, site_id);
			Swal.fire({
				title: t("aux.messages.alert.success"),
				text: t("aux.messages.alert.text_alert.download_success"),
				icon: "success",
			});
		} catch (error) {
			Swal.fire({
				title: t("aux.messages.alert.error"),
				text: t("aux.messages.alert.text_alert.error_download"),
				icon: "error",
			});
			console.error("Error al obtener la demanda:", error);
		} finally {
			setIsDownloading(false);
		}
	};
	const fileInputRef = useRef(null);

	const handleFileDrop = (event) => {
		event.preventDefault();
		const file = event.dataTransfer.files[0];
		setSelectedFile(file);
	};

	const handleDragOver = (event) => {
		event.preventDefault();
	};

	const openFileDialog = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const handleFileChange = (event) => {
		const file = event.target.files[0];
		setSelectedFile(file);
		handleFileSelection(file);
	};
	const handleUpload = () => {
		// Aquí puedes manejar la lógica de carga del archivo
		if (selectedFile) {
			setIsUploading(true);
			// Utiliza SweetAlert para confirmar el envío del archivo
			Swal.fire({
				title: t("aux.messages.sure"),
				text: t("aux.messages.sure_file"),
				icon: "question",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: t("aux.buttons.yes"),
			}).then((result) => {
				if (result.isConfirmed) {
					// use uploadFile function
					uploadFile(`/files/upload_store_config?site_id=${site_id}`, selectedFile)
						.then(() => {
							setSelectedFile(null);
							const moduleId = getModuleId(
								"Carga de Archivos",
								"Restaurante",
								"Carga de archivo de restaurant"
							);
							auditPost(moduleId, site_id);
							Swal.fire({
								title: t("aux.messages.alert.success"),
								text: t("aux.messages.alert.text_alert.send_file"),
								icon: "success",
							}).then(() => {
								setSelectedFile(null);
							});
							setIsUploading(false);
						})
						.catch((error) => {
							// Maneja errores en caso de que la carga falle
							Swal.fire({
								title: t("aux.messages.alert.error"),
								text: t("aux.messages.alert.text_alert.error_send_file"),
								icon: "error",
							});
							console.error("Error al enviar el archivo:", error);
						});
				}
			});
		} else {
			// Si no se ha seleccionado un archivo, muestra un mensaje de error
			Swal.fire({
				title: t("aux.messages.alert.error"),
				text: t("aux.messages.alert.text_alert.error_send_file"),
				icon: "error",
			});
		}
	};

	const handleFileSelection = (file) => {
		setSelectedFile(file);
	};

	return (
		<>
			{/* Contenedor Principal */}
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					flexDirection: "column",
					alignItems: "center",
					padding: "16px", // Puedes ajustar el padding según tus preferencias
					marginTop: "16px", // Puedes ajustar el margen superior según tus preferencias
				}}
			>
				<Typography variant="h5" gutterBottom>
					{t("upload.preparar_archivo")}
				</Typography>
				{/* Contenedor Componente FormDown */}
				<Box
					sx={{
						p: 2,
						width: "75%",
					}}
				>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Button
								disabled={
									!isGranted("Carga de Archivos", "Restaurante", "Botón de descargar formato") ||
									isDownloading
								}
								variant="contained"
								color="primary"
								size="large"
								sx={{
									width: "100%",
								}}
								onClick={handleClickButton}
							>
								{isDownloading ? t("aux.downloading") : t("aux.buttons.download")}
							</Button>
						</Grid>
					</Grid>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						width: "75%",
						flexDirection: "column",
						alignItems: "center",
						padding: "16px",
						marginTop: "16px",
					}}
				>
					<Typography variant="h5" gutterBottom>
						{t("upload.title")}
					</Typography>
					<Box
						onDragOver={handleDragOver}
						onDrop={handleFileDrop}
						sx={{
							border: "1px solid #ccc",
							borderRadius: "8px",
							padding: "16px",
							width: "100%", // Hacer que el Input ocupe todo el ancho del contenedor
							margin: "0 auto",

							cursor: "pointer",
							mb: 2,
						}}
						onClick={openFileDialog}
					>
						<Grid container justifyContent="center" spacing={2}>
							<Grid
								item
								xs={12}
								sm={6}
								textAlign="center"
								disabled={!isGranted("Carga de Archivos", "Restaurante", "Carga de archivo de restaurant")}
							>
								{/* Input para seleccionar el archivo */}
								<input
									style={{ display: "none" }}
									id="upload-input"
									type="file"
									onChange={handleFileChange}
								/>

								<label htmlFor="upload-input">
									<IconButton component="span" sx={{ fontSize: "10rem" }}>
										<FileUploadIcon
											sx={{
												width: "100%",
												fontSize: 300,
											}}
										/>
									</IconButton>
								</label>

								{selectedFile && (
									<Typography variant="body1" sx={{ mt: 1 }}>
										{selectedFile.name}
									</Typography>
								)}
							</Grid>
						</Grid>
					</Box>

					<Button
						disabled={
							!isGranted("Carga de Archivos", "Restaurante", "Carga de archivo de restaurant") ||
							isUploading
						}
						variant="contained"
						size="large"
						color="primary"
						onClick={handleUpload}
						style={{
							width: "100%",
						}}
					>
						{isUploading ? t("upload.site.uploading") : t("upload.site.button")}
					</Button>
				</Box>
			</Box>
		</>
	);
};

export { Restaurant };
